var map = {
	"./-1.jpg": 574,
	"./0.jpg": 575,
	"./1.jpg": 576,
	"./10.jpg": 577,
	"./2.jpg": 578,
	"./3.jpg": 579,
	"./4.jpg": 580,
	"./5.jpg": 581,
	"./6.jpg": 582,
	"./7.jpg": 583,
	"./8.jpg": 584,
	"./9.jpg": 585,
	"./aris.jpg": 498,
	"./atamd.jpg": 499,
	"./belgeler.jpg": 500,
	"./bilge.jpg": 501,
	"./erdem.jpg": 502,
	"./hoyuk.jpg": 503,
	"./kitap.jpg": 586,
	"./tdkbelleten.jpg": 504,
	"./ttkbelleten.jpg": 505,
	"./turkdili.jpg": 506,
	"./turkdunyasi.jpg": 507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;